import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Bell } from 'lucide-react';
import { supabase } from '@/lib/supabaseClient';

const AppHeader: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };

  return (
    <header className="flex items-center justify-between whitespace-nowrap border-b border-solid border-b-[#f0f2f5] px-10 py-3">
      <div className="flex items-center gap-8">
        <div className="flex items-center gap-4 text-[#111418]">
          <div className="size-4">
            {/* Icono de PropertyPro */}
            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M24 4H42V17.3333V30.6667H24V44H6V30.6667V17.3333H24V4Z" fill="currentColor"></path>
            </svg>
          </div>
          <h2 className="text-[#111418] text-lg font-bold leading-tight tracking-[-0.015em]">Inquilapp</h2>
        </div>
        <div className="flex items-center gap-9">
          <Link className="text-[#111418] text-sm font-medium leading-normal" to="/dashboard">Dashboard</Link>
          <Link className="text-[#111418] text-sm font-medium leading-normal" to="/buildings">Edificios</Link>
          <Link className="text-[#111418] text-sm font-medium leading-normal" to="/tenants">Inquilinos</Link>
          
          <Link className="text-[#111418] text-sm font-medium leading-normal" to="/reports/delinquent-tenants">Reportes</Link>
        </div>
      </div>
      <div className="flex flex-1 justify-end gap-8">
        <label className="flex flex-col min-w-40 !h-10 max-w-64">
          <div className="flex w-full flex-1 items-stretch rounded-lg h-full">
            <div
              className="text-[#60758a] flex border-none bg-[#f0f2f5] items-center justify-center pl-4 rounded-l-lg border-r-0"
            >
              {/* Icono de búsqueda */}
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
                <path
                  d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"
                ></path>
              </svg>
            </div>
            <Input
              placeholder="Buscar"
              className="flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-[#111418] focus:outline-0 focus:ring-0 border-none bg-[#f0f2f5] focus:border-none h-full placeholder:text-[#60758a] px-4 rounded-l-none border-l-0 pl-2 text-base font-normal leading-normal"
            />
          </div>
        </label>
        <Button
          className="flex max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-10 bg-[#f0f2f5] text-[#111418] gap-2 text-sm font-bold leading-normal tracking-[0.015em] min-w-0 px-2.5"
        >
          <Bell size={20} />
        </Button>
        <div
          className="bg-center bg-no-repeat aspect-square bg-cover rounded-full size-10"
          style={{ backgroundImage: 'url("https://lh3.googleusercontent.com/aida-public/AB6AXuApPETaPV2dOOr14EM-zY-km4oQlG6Y-KVqCQoIMj777fmqXk8UOLfytqAaDtbGwDueUR-Gp-r3rVXqU8OD2DHY1R_cakLvusdeP5IakLP75CL9sDdzImk6EIHssZ5i3q2OsaGa-tLtP1tq1470ZyAzbxEQtzmszezjUgHJi3TGJRzNuZp3WU7tmF8pfyNch38U3ZrCQoIMj777fmqXk8UOLfytqAaDtbGwDueUR-Gp-r3rVXqU8OD2DHY1R_cakLvusdeP5IakLP75CL9sDdzImk6EIHssZ5i3q2OsaGa-tLtP1tq1470ZyAzbxEQtzmszezjUgHJi3TGJRzNuZp3WU7tmF8pfyNch38U3ZrCYIxMetxZ50wce9R531CT99xD00sZcBSQxrXzzL37tu_5sXe_eIGUU-iZIeMIdP80Co8goMAN")' }}
        ></div>
        <Button onClick={handleLogout} variant="secondary">Cerrar Sesión</Button>
      </div>
    </header>
  );
};

export default AppHeader;